import { render, staticRenderFns } from "./Monitoreo.vue?vue&type=template&id=c0205c36&scoped=true&"
import script from "./Monitoreo.vue?vue&type=script&lang=ts&"
export * from "./Monitoreo.vue?vue&type=script&lang=ts&"
import style0 from "./Monitoreo.vue?vue&type=style&index=0&id=c0205c36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0205c36",
  null
  
)

export default component.exports